import React from 'react';
import PropTypes from 'prop-types';
import { StyledCtaShell } from './styles.js';

/**
 * Layout shell for CTAs nested in page sections.
 * Owns stretch-to-parent when full-width flags are set so inner LinkButton /
 * CtaButton resolves against a real containing block (not fit-content).
 */
export const CtaShell = ({
  children,
  fullWidth = false,
  fullWidthMobile = false,
  fullWidthDesktop = false,
  defaultWidth,
  className,
  ...rest
}) => (
  <StyledCtaShell
    className={className}
    $fullWidth={fullWidth}
    $fullWidthMobile={fullWidthMobile}
    $fullWidthDesktop={fullWidthDesktop}
    $defaultWidth={defaultWidth}
    {...rest}
  >
    {children}
  </StyledCtaShell>
);

CtaShell.displayName = 'CtaShell';

CtaShell.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool,
  fullWidthMobile: PropTypes.bool,
  fullWidthDesktop: PropTypes.bool,
  defaultWidth: PropTypes.string,
  className: PropTypes.string,
};
